const Button = ({
	text,
	icon: Icon,
	onClick,
	color = "blue",
	className,
	classNameIcon,
	disabled,
	position = "before",
	title = "",
	cssButtonTitleSm = "sm:text-[9px]",
}) => {
	const baseClasses = `
    flex items-center justify-center 
    font-normal rounded-lg text-[10px] ${cssButtonTitleSm} md:text-xs
    py-2 px-2 sm:py-1 sm:px-1.5 md:py-2 md:px-2
    text-center me-2
  `;

	const colorClasses = {
		blue: "bg-blue-gray focus:ring-blue-900 hover:bg-blue-gray hover:bg-opacity-40 gap-1",
		red: "bg-red-600 hover:bg-red-500 focus:ring-red-600",
		dark: "text-gray-100 text-xs font-semibold bg-gray-700 hover:bg-gray-600 focus:ring-blue-700",
	};

	const iconbaseClasses = "flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 shrink-0";
	return (
		<button
			type="button"
			className={`${baseClasses} ${colorClasses[color]} ${className} flex items-center justify-center gap-2 disabled:cursor-not-allowed disabled:opacity-50`}
			onClick={onClick}
			disabled={disabled}
			title={title}
		>
			{Icon && position === "before" && (
				<Icon className={`${iconbaseClasses} ${classNameIcon}`} aria-hidden="true" />
			)}

			{text && <span className="flex items-center leading-none">{text}</span>}

			{Icon && position === "after" && (
				<Icon className={`${iconbaseClasses} ${classNameIcon}`} aria-hidden="true" />
			)}
		</button>
	);
};

export default Button;
